import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions } from '@/api/react-query'
import { ResendSignupCodeBody } from '@/types'

export async function resendSignupCode(body: ResendSignupCodeBody) {
  const response = await httpClient('user-manager').post(
    '/v1/signup/resend',
    body,
  )

  return response.data
}

export function useResendSignupCode(
  options?: MutationOptions<unknown, ResendSignupCodeBody>,
) {
  return useMutation({
    mutationFn: resendSignupCode,
    ...options,
  })
}
